import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

type LoggingOutWarning = {
  isLoggingOutWarning: boolean
  isConfirmedLogout: boolean
  idEditMode: boolean
}

const initialState: LoggingOutWarning = {
  isLoggingOutWarning: false,
  isConfirmedLogout: false,
  idEditMode: false, 
}

export const LoggingOutWarningSlice = createSlice({
  name: 'loggingOutWarning',
  initialState,
  reducers: {
    setLoggingOutWarning: (state, action: PayloadAction<boolean>) => {
      state.isLoggingOutWarning = action.payload
    },
    setConfirmedLogout: (state, action: PayloadAction<boolean>) => {
      state.isConfirmedLogout = action.payload
    },
    setEditMode: (state, action: PayloadAction<boolean>) => {
      state.idEditMode = action.payload 
    },
  },
})

export const { setLoggingOutWarning, setConfirmedLogout, setEditMode } = LoggingOutWarningSlice.actions

export const getIsLoggingOutWarning = (state: RootState) => state.loggingOutWarning.isLoggingOutWarning
export const getIsConfirmedLogout = (state: RootState) => state.loggingOutWarning.isConfirmedLogout
export const getIsEditMode = (state: RootState) => state.loggingOutWarning.idEditMode

export default LoggingOutWarningSlice.reducer